import React from 'react';

import { useForm } from 'react-hook-form';
import { Button, LbInput, Surface } from '@infoods/lifebase-ui';
import { enqueueSnackbar } from 'notistack';

import { angularizeWithProviders } from '../../../shared/providers';
import classes from './NgzForgotPassword.module.scss';
import { AuthPageLayout } from '../../components/AuthPageLayout/AuthPageLayout';
import { authService } from '../../services/authService';
import { goTo } from '../../../shared/utils/angularUtils';
import { validateEmail } from '../../../shared/utils/reactHookFormUtils';

type FormData = {
  email: string;
};

const NgzForgotPassword = () => {
  const { control, handleSubmit } = useForm<FormData>({
    mode: 'onBlur',
  });

  const onSubmit = async (data: FormData) => {
    await authService.resetPassword(data.email);
    enqueueSnackbar('Message with reset link sent to email.', { variant: 'success' });
    goTo('/');
  };

  return (
    <AuthPageLayout>
      <Surface
        as="form"
        radius="l"
        className={classes.form}
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <h2 className={classes.title}>Forgot Password</h2>
        <p className={classes.description}>
          Enter the email you used to register with SWYMO. A &quot;Forgot Password&quot;
          email with instructions will be sent to you and return to login
        </p>
        <LbInput
          control={control}
          label="Email"
          name="email"
          type="email"
          rules={{
            required: 'Email is required',
            validate: { validateEmail },
          }}
        />
        <Button className={classes.button} variant="contained" fullWidth type="submit">
          Send
        </Button>
        <Button className={classes.backButton} variant="outlined" href="/" fullWidth>
          Back to Login
        </Button>
      </Surface>
    </AuthPageLayout>
  );
};

angularizeWithProviders(NgzForgotPassword, 'ngzForgotPassword', {});

export default NgzForgotPassword;
